import React from "react";
import { Header } from "../survey-types";

interface HeaderFormProps {
  header: Header;
  onHeaderChange: (key: keyof Header, value: string | Date) => void;
}

export const HeaderForm: React.FC<HeaderFormProps> = ({
  header,
  onHeaderChange,
}) => {
  return (
    <div>
      <div className="mb-4">
        <input
          type="text"
          id="title"
          className="bg-slate-600 text-white text-xl w-full sm:w-[800px]"
          placeholder="Survey Title"
          value={header?.title}
          onChange={(e) => onHeaderChange("title", e.target.value)}
        />
      </div>
      <div className="mb-4">
        <label className="block mt-8" htmlFor="description">
          Describe the context and goal of your survey:
        </label>
        <textarea
          id="description"
          className="bg-slate-600 text-white text-sm mt-2 w-full sm:w-[800px] h-32"
          placeholder="E.g., Evaluate the potential market reception of a new face cream."
          value={header?.contextAndObjectives}
          onChange={(e) =>
            onHeaderChange("contextAndObjectives", e.target.value)
          }
          rows={4}
        />
      </div>
    </div>
  );
};
